if (!customElements.get('catarette-gallery')) {
  customElements.define('catarette-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const {signal} = this.controller;
      this.track = this.querySelector('.ct-gallery-track');
      this.slides = [...this.querySelectorAll('.ct-gallery-slide')];
      this.thumbs = [...this.querySelectorAll('[data-gallery-index]')];
      this.prev = this.querySelector('[data-gallery-prev]');
      this.next = this.querySelector('[data-gallery-next]');
      this.status = this.querySelector('[data-gallery-status]');
      this.index = 0;
      this.thumbs.forEach((button, i) => button.addEventListener('click', () => this.go(i), {signal}));
      this.prev.addEventListener('click', () => this.go(this.index - 1), {signal});
      this.next.addEventListener('click', () => this.go(this.index + 1), {signal});
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          const trackRect = this.track.getBoundingClientRect();
          let nearest = 0, distance = Infinity;
          this.slides.forEach((slide, i) => { const d = Math.abs(slide.getBoundingClientRect().left - trackRect.left); if (d < distance) {distance = d; nearest = i;} });
          this.index = nearest;
          this.update();
        });
      }, {passive:true, signal});
      this.track.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {event.preventDefault(); this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));}
      }, {signal});
      this.update();
    }
    go(index) {
      this.index = Math.max(0, Math.min(this.slides.length - 1, index));
      const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollTo({left: this.index * this.track.clientWidth, behavior: reduced ? 'instant' : 'smooth'});
      this.update();
    }
    update() {
      this.thumbs.forEach((button, i) => { if (i === this.index) button.setAttribute('aria-current', 'true'); else button.removeAttribute('aria-current'); });
      this.prev.disabled = this.index === 0;
      this.next.disabled = this.index === this.slides.length - 1;
      this.status.textContent = `${this.index + 1} / ${this.slides.length}`;
    }
    disconnectedCallback() {this.controller?.abort(); this.controller = null; cancelAnimationFrame(this.frame);}
  });
}
// Native Shopify localization submission keeps the current product/view query.
document.addEventListener('submit', event => {
  if (!event.target.matches('.ct-language-switch')) return;
  const returnTo = event.target.querySelector('input[name="return_to"]');
  if (returnTo) returnTo.value = window.location.pathname + window.location.search;
});
document.addEventListener('click', event => {
  const menu = document.querySelector('.ct-mobile-menu[open]');
  if (menu && (!menu.contains(event.target) || event.target.closest('a'))) menu.open = false;
});
document.addEventListener('keydown', event => {
  if (event.key === 'Escape') {
    const menu = document.querySelector('.ct-mobile-menu[open]');
    if (menu) {menu.open = false; menu.querySelector('summary').focus();}
  }
});

if (!customElements.get('catarette-bundles')) {
 customElements.define('catarette-bundles', class extends HTMLElement {
  connectedCallback() {
   this.controller?.abort();
   this.controller = new AbortController();
   const {signal} = this.controller;
   this.form = document.getElementById(this.dataset.formId);
   this.input = this.form?.elements.namedItem('quantity');
   const buttons = [...this.querySelectorAll('[data-bundle-quantity]')];
   if (!this.input) { buttons.forEach(button => button.disabled = true); return; }
   this.update = () => {
    const quantity = Number(this.input.value) || 1;
    const minimum = Number(this.input.min) || 1;
    const maximum = this.input.max ? Number(this.input.max) : Infinity;
    const step = Number(this.input.step) || 1;
    buttons.forEach(button => {
     const value = Number(button.dataset.bundleQuantity);
     button.disabled = value < minimum || value > maximum || (value - minimum) % step !== 0;
     button.setAttribute('aria-pressed', String(value === quantity));
    });
    this.querySelector('.ct-bundle-status').textContent = (quantity === 1 ? this.dataset.selectedOne : this.dataset.selectedMany).replace('__COUNT__', String(quantity)).replace('__STICKS__', String(quantity * 3));
   };
   buttons.forEach(button => button.addEventListener('click', () => {
    this.input.value = button.dataset.bundleQuantity;
    this.input.dispatchEvent(new Event('change', {bubbles: true}));
    this.update();
   }, {signal}));
   this.input.addEventListener('change', this.update, {signal});
   this.input.addEventListener('input', this.update, {signal});
   this.update();
  }
  disconnectedCallback() { this.controller?.abort(); }
 });
}
